import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import HoldActions from 'app/actions/HoldActions';
import BorrowingActions from 'app/actions/BorrowingActions';
import { currentAccountSelector } from 'app/selectors/AuthSelector';

const HoldsContainer = loadable(() => import('app/components/borrowing/holds/Holds/HoldsContainer'));

export function HoldsPageRoute() {
  return <HoldsContainer />;
}

function getRouteData({ dispatch, state, params, query }) {
  const account = currentAccountSelector(state);
  const accountId = account && account.get('id');
  if (!accountId) return [];

  return [
    dispatch(BorrowingActions.fetchSummaries({ accountId })),
    dispatch(HoldActions.fetchHolds({ accountId, ...params, ...query }))
  ];
}

export default connectRoute(HoldsPageRoute, { getRouteData });
